export default "__VITE_ASSET__B_b3eiKM__"